import { makeStyles } from 'vendor/material';

const useStyles = makeStyles((theme) => ({
  tooltip: {
    marginLeft: '-5px',
  },
}));

export default useStyles;
